import { Component, Inject } from '@angular/core';
import { ReminderPopupInterface, ReminderPopupModel } from './reminder-popup.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-reminder-popup',
    templateUrl: './reminder-popup.component.html',
})
export class ReminderPopupComponent {
    data = new ReminderPopupModel({} as ReminderPopupInterface);

    constructor(@Inject(MAT_DIALOG_DATA) private popupData: ReminderPopupInterface) {
        this.data = new ReminderPopupModel(popupData);
    }
}

export function openReminderDialog(dialog: MatDialog, popupData?: ReminderPopupInterface): Observable<boolean> {
    const config = new MatDialogConfig();

    config.autoFocus = false;
    config.disableClose = false;
    config.disableClose = true;
    config.maxWidth = '43.75rem';
    config.panelClass = 'reminder-popup-dialog';
    config.data = { ...popupData };

    return dialog.open(ReminderPopupComponent, config).afterClosed();
}
